import React, {useState, useRef} from "react";
import styles from "./styles.css";
import LazyImage from "../../shared/lazy-image";
import PropTypes from "prop-types";
import { NUMBER } from "../../../constants/app-constants";
import { appUrl } from "../../../constants/url-constants";
import { sendCustomGaEvents } from "../../../tracking";
import { stateSelected } from "./tracking";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";

const EChallanStates = ({
    title = "View traffic rules and challans in your area",
    description = "Find information about traffic fines and offences in your state",
    stateList = [],
    limit = NUMBER.FOUR,
    stateSlug = "",
    isSSR = false
}) => {

    const listRef = useRef();
    const [isOpen, setIsOpen] = useState(false);

    const onViewMoreHandler = () => {
        if (isOpen && listRef && listRef.current) {
            window.setTimeout(() => {
                listRef.current.scrollIntoView();
            }, NUMBER.ZERO);
        }
        setIsOpen(!isOpen);
    };

    const onClickHandler = async (stateName) => {
        await yieldToMain();
        sendCustomGaEvents({
            ...stateSelected,
            eventLabel: stateName
        });
    };

    const renderStateList = () => (
        stateList && !!stateList.length && stateList.map((item) => (
            (stateSlug !== item.slug) &&
            <a
                href={`${appUrl()}/${item.slug || ""}-traffic-challan-status/`}
                key={item.state_code}
                onClick={() => onClickHandler(item.state_name)}
            >
                <div styleName={"styles.eChallanLocateWiseCard"}>
                    <LazyImage visibleByDefault={isSSR} src={item.state_image} alt={`${item.state_name} Traffic eChallan`} width="230px" height="180px" />
                    <h3>Pay Challan in {item.state_name}</h3>
                </div>
            </a>
        ))
    );

    return (
        <div styleName={`styles.eChallanLocateWiseChallans ${isOpen ? "styles.eChallanLocateWiseChallansText" : ""}`}>
            <h2>{title}</h2>
            <p>{description}</p>
            <div ref={listRef} styleName={"styles.eChallanLocateWiseWrapper"}>
                {renderStateList()}
            </div>
            { stateList && stateList.length > limit &&
                <div styleName={"styles.viewMore"} className="shrinkOnTouch" onClick={onViewMoreHandler}>
                    {isOpen ? "View less states" : "View all states"}
                </div>
            }
        </div>
    );
};

EChallanStates.propTypes = {
    title: PropTypes.string,
    stateList: PropTypes.array.isRequired,
    limit: PropTypes.number,
    description: PropTypes.string,
    stateSlug: PropTypes.string,
    isSSR: PropTypes.bool
};

export default EChallanStates;
